import React from "react";
import FaqAccordion from "../faqAccordion/faqAccordion";

const Blog8 = ({ blog }) => {
  return (
    <div className="parent-container">
      <div className="main-container-blogpage" id="blog-content-container">
        <div className="category-tag">{blog.category}</div>
        <p className="headline-page">{blog.mainTitlePage}</p>
        <p className="date">{blog.publishDate}</p>
        <div className="image-container">
          <img className="img" src={blog.detailImage} alt={blog.imageAlt} />
        </div>

        <p className="paragraph-content">
          Foreign trip ka sapna sabka hota hai – Eiffel Tower, Santorini
          sunsets, or Singapore shopping.
          <br />
          But for most of us, ek hi problem hai – “Budget nahin ban raha.”
          <br />
          Flights expensive, hotels mehenga, and salary bas khatam hone ki race
          mein hoti hai.
        </p>

        <p className="paragraph-content">
          You don’t need a miracle bonus or rich relatives.
          <br />
          You just need a plan – one that quietly builds your travel fund while
          life goes on.
        </p>

        <p className="sub-paragraph-heading">
          Step 1: Start a Travel Jar – But Smarter
        </p>

        <p className="paragraph-content">
          Remember how mom used to keep loose change in a bartan?
          <br />
          Now do it digitally.
          <br />
          Set an auto-save on kPaisa – ₹50, ₹100, ₹500 a week.
          <br />
          Before you know it, your “vacay jar” turns into your ticket fund.
        </p>

        <p className="sub-paragraph-heading">
          Step 2: Track Where Your Money Actually Goes
        </p>

        <p className="paragraph-content">
          Half the “I can’t save” is just invisible spending.
          <br />
          Use kPaisa’s expense tracker – dekho kitna paisa Zomato, cabs, aur
          impulse shopping kha jaata hai.
          <br />
          Awareness is the first saving.
        </p>

        <p className="sub-paragraph-heading">
          Step 3: Make Your Money Earn While You Wait
        </p>

        <p className="paragraph-content">
          Don’t just keep your savings sitting.
          <br />
          Turn them into digital gold or a short-term mutual fund through
          kPaisa.
          <br />
          Even an 8% return adds real value – that’s one flight ticket free just
          from compounding.
        </p>

        <p className="sub-paragraph-heading">Step 4: Cut, But Don’t Kill Joy</p>

        <p className="paragraph-content">
          Pack home lunch twice a week.
          <br />
          Skip one subscription.
          <br />
          Each small change goes straight into your travel fund.
          <br />
          (And trust me, Italy ka pasta tastes better when you’re debt-free.)
        </p>

        <p className="sub-paragraph-heading">Step 5: Plan Ahead, Pay Less</p>

        <p className="paragraph-content">
          Book flights early.
          <br />
          Travel off-season.
          <br />
          Use kPaisa rewards to offset small travel expenses – it’s the cashback
          that feels like destiny.
        </p>

        <p className="paragraph-content">
          The truth? You don’t need more income.
          <br />
          You need a system that saves automatically – even when you forget.
          <br />
          That’s how trips move from “someday” to “booked.”
        </p>

        <p className="paragraph-content">
          Every traveler has two stories:
          <br />
          One who waited for “the right time,” and one who started with ₹50.
          <br />
          Open kPaisa → Start a Travel Goal → Auto-save and invest.
          <br />
          Your boarding pass might already be in progress.
        </p>

        <p className="paragraph-content">
          There’s a feature inside kPaisa that makes small savers behave like
          investors. You’ll see it the moment you log in.
        </p>

        <div className="faq-heading-container">
          <p className="sub-paragraph-heading-faq">
            Frequently asked questions
          </p>
        </div>
        <FaqAccordion>
          <h4 className="faq-question">
            Can I save for travel with small amounts?
          </h4>
          <p className="faq-answer">
            Yes. Even ₹10–₹100 auto-saves grow over months through compounding
            and rewards.
          </p>
        </FaqAccordion>
        <FaqAccordion>
          <h4 className="faq-question">
            What if my income changes every month?
          </h4>
          <p className="faq-answer">
            kPaisa’s flexible auto-save adjusts automatically – you can pause or
            restart anytime, bina stress.
          </p>
        </FaqAccordion>
        <FaqAccordion>
          <h4 className="faq-question">Can I withdraw money when needed?</h4>
          <p className="faq-answer">
            Absolutely. Liquidity is built in. Withdraw instantly or use a small
            kPaisa travel loan to fill any gap.
          </p>
        </FaqAccordion>
        <br></br>
        <br></br>
      </div>
    </div>
  );
};

export default Blog8;
